import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SearchPage } from '../search/search';
import { CabsandFleetinfoPage } from '../cabsand-fleetinfo/cabsand-fleetinfo';
import { SelectImageAddPage } from '../select-image-add/select-image-add';

@IonicPage()
@Component({
  selector: 'page-cabsand-fleetinfo-add',
  templateUrl: 'cabsand-fleetinfo-add.html',
})
export class CabsandFleetinfoAddPage {
  params: any = {};
  appColor: String;
  actionAllowed: boolean = false;
  labourCostAllowed: boolean = false;
  selectOptions: any;
  perLitreAmount: any = null;
  createFleet: FormGroup;
  isUpdate: boolean = false;

  locationList:any = [];
  vehicleCategoryList:any = [];
  vehicleTypeList:any = [];
  allFuelList:any = [];
  maintenanceList:any = [];
  labourCostList:any = [];
  imageList:any = [];

  location:any = "Select";
  vehicleCategory:any = "Select";
  vehicleType:any = "Select";

  categoryId:any = null;

  
  isDisabled: boolean = false;
  disableSubmit: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder, private modalController: ModalController) {
    this.selectOptions = {
      mode: 'ios'
    };

    this.params = this.navParams.get('param');
    this.isDisabled = this.navParams.get('disable');

    if (this.params) {
      this.isUpdate = true;
      console.log("this.params",this.params)
    }
    let currentDate = new Date()
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
    this.createFleet = this.formBuilder.group({
      fleet_no: new FormControl('', [Validators.required]),
      unit_description: new FormControl('', [Validators.required]),
      year_model: new FormControl(''),
      engine_no: new FormControl(''),
      chassis_no: new FormControl('', [Validators.required]),
      rego_no: new FormControl(''),
      amount_purchase: new FormControl('', [Validators.required]),
      date_purchase: new FormControl(date),
      sale_price: new FormControl(''),
      location: new FormControl(''),
      vehicle_category: new FormControl(''),
      vehicle_type: new FormControl(''),
      
      serviced_hrs: new FormControl(''),
      serviced_kms: new FormControl(''),
      current_kms: new FormControl(''),
      current_hrs: new FormControl(''),
      kms_service_due: new FormControl(''),
      Rego_Due_Date: new FormControl(''),
      rego_date: new FormControl(''),
      suppression_serviced: new FormControl(''),
      suppression_due: new FormControl(''),
      new_price: new FormControl(''),


      vehicle_status: new FormControl('1'),
    });
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getappColor();
    this.getMetaData();
    if(this.isUpdate){
      this.getPermissions();
    }
    
      }
    
      async getPermissions(){
        this.labourCostAllowed = await this.utiltiy.getPagePermission("cabsand-labour-cost");
      }
  async getappColor() {
    this.appColor = await this.utiltiy.getStorage("primaryColor");
  }


  async getMetaData() {
    this.utiltiy.startLoading();
    this.locationList = await this.getData("get_location");
    this.vehicleCategoryList = await this.getData("get_vehicle_category");
    this.vehicleTypeList = await this.getData("get_vehicle_type");
    if (this.params) {
      let allFuelList = await this.getData("all_fuel");
      let maintenanceList = await this.getData("maintenance");
      let labourCostList = await this.getData("labour_cost");
      this.calculateFuelList(allFuelList);
      this.calculateMaintenanceList(maintenanceList);
      this.calculateLabourList(labourCostList);
      this.regenerateForm();
      this.utiltiy.stopLoading();
      this.getImageData();
    }else{
      this.utiltiy.stopLoading();
    }
  }

  async getMaintenaceData(){
    let maintenanceList = await this.getData("maintenance");
    this.calculateMaintenanceList(maintenanceList);
  }

 

  async getImageData(){
    this.utiltiy.startLoading();
    this.imageList = await this.getData("get_image_fleet_information");
    this.utiltiy.stopLoading();

  }

  async calculateFuelList(allFuelList){
    let array = [];
    let keys = Object.keys(allFuelList);

    keys.forEach(element => {
      let monthKeys = Object.keys(allFuelList[element].months)
      let childArray = [];
      let obj = {} as any;
      obj.name = element;
      obj.amount = 0;
      obj.litre = 0;
      monthKeys.forEach(element_ => {
        const monthNames = ["","January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        obj.amount =  obj.amount + parseFloat(allFuelList[element].months[element_].totalamount)
        obj.litre =   obj.litre + parseFloat(allFuelList[element].months[element_].totalfuel)
        allFuelList[element].months[element_]['monthName'] = monthNames[allFuelList[element].months[element_].month]
        childArray.push(allFuelList[element].months[element_])
      });
      obj.children = childArray
      array.push(obj)
    });
    this.allFuelList = array;

  }


  async calculateLabourList(maintenanceList){
   console.log(maintenanceList)
    let array = [];
    let keys = Object.keys(maintenanceList);

    keys.forEach(element => {
      let monthKeys = Object.keys(maintenanceList[element].months)
      let childArray = [];
      let obj = {} as any;
      obj.name = element;
      obj.value = maintenanceList[element].year_labour_cost[0];
      monthKeys.forEach(element_ => {
        const monthNames = ["","January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        childArray.push({"records":maintenanceList[element].months[element_], "monthName": monthNames[element_],"value":maintenanceList[element].months[element_].month_labour_cost})
      });
      obj.children = childArray
      array.push(obj)
    });
      this.labourCostList = array;
    
    console.log(array)
    // this.maintenanceList = array;
  }


  async calculateMaintenanceList(maintenanceList){
   
    let array = [];
    let keys = Object.keys(maintenanceList);

    keys.forEach(element => {
      let monthKeys = Object.keys(maintenanceList[element].months)
      let childArray = [];
      let obj = {} as any;
      obj.name = element;
      monthKeys.forEach(element_ => {
        const monthNames = ["","January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        childArray.push({"records":maintenanceList[element].months[element_], "monthName": monthNames[element_]})
      });
      obj.children = childArray
      array.push(obj)
    });
    this.maintenanceList = array;
  }

  fueltoggleSection(i){
    this.allFuelList[i].open = !this.allFuelList[i].open;
  }

  fueltoggleItem(i,j){
    this.allFuelList[i].children[j].open = ! this.allFuelList[i].children[j].open;
  }
  
  maintenancetoggleSection(i){
    this.maintenanceList[i].open = !this.maintenanceList[i].open;
  }

  maintenancetoggleItem(i,j){
    this.maintenanceList[i].children[j].open = ! this.maintenanceList[i].children[j].open;
  }
  
  labourtoggleSection(i){
    this.labourCostList[i].open = !this.labourCostList[i].open;
  }

  labourtoggleItem(i,j){
    this.labourCostList[i].children[j].open = ! this.labourCostList[i].children[j].open;
  }

  buyItem(item){
    console.log(item)
  }


async deleteImage(id){
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "delete_image");
    formData.append("image_id", id);
     this.api.post("/tansix_prestart/Fleet_Information/Fleet_Information", false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
            this.getImageData();
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }


  editImage(data){
    let payload = data;
    this.imagePopup(payload);
  }

  addImage(){
    let payload = null;
    this.imagePopup(payload);
  }




  async getData(method){
    let formData: FormData = new FormData();
    formData.append("method_name", method);
    switch (method) {
      case "all_fuel":
       formData.append("plantitem_id", this.params.id);
        break;

      case "maintenance":
        formData.append("plantitem_id", this.params.id);
        break;

      case "get_image_fleet_information":
        formData.append("plantitem_id", this.params.id);
        break;
      case "labour_cost":
          formData.append("plantitem_id", this.params.id);
          break;  
    }
    return this.api.post("/tansix_prestart/Fleet_Information/Fleet_Information", false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }


  async imagePopup(payload){
    const modal = await this.modalController.create(
      SelectImageAddPage,
      {
        data:payload,
        id:this.params.id,
        isKlmr:true,
      },
      { enableBackdropDismiss: false }
    );
    modal.onDidDismiss((status) => {
      if(status){
        this.getImageData();
      }
     console.log("status",status)
    });
    await modal.present();
  }

  searchMaintenance(value){
    console.log("value is",value)
    let formData: FormData = new FormData();
    formData.append("method_name","search_maintenance");
    formData.append("search_maintenance",value);
    formData.append("plantitem_id", this.params.id);
    this.utiltiy.startLoading();
    this.api.post(`/tansix_prestart/Fleet_Information/Fleet_Information`, false, formData)
    .then((result: any) => {
      console.log("result", result);
      this.utiltiy.stopLoading();
      if (result.status) {
      this.calculateMaintenanceList(result.result);

      }else{
      this.utiltiy.toaster(result.message);
      this.getMaintenaceData();

      }

    }, err => {
      console.log("err", err);
      this.utiltiy.stopLoading();
      this.utiltiy.toaster(err.error.message);
    });
  }

  


  submit() {
    this.utiltiy.startLoading();
    this.disableSubmit = true;
    let formKeys = Object.keys(this.createFleet.value);
      if (this.isUpdate) {
        // let string = "";
        // formKeys.forEach(key => {
        //   if (string.length == 0) {
        //     string = string + "" + key + "=" + this.createFleet.value[key];
        //   } else {
        //       string = string + "&" + key + "=" + this.createFleet.value[key];
            
        //   }
        // });
        // let body = string;
        // console.log("string-1", body);
        // formData.append("method_name", "store_fleet_information");
        // this.addFleetInfo(formData);
        let formData: FormData = new FormData();
        formKeys.forEach(key => {
          formData.append(key, this.createFleet.value[key]);
        });
        formData.append("method_name", "edit_fleet_information");
        formData.append("id", this.params.id);
        this.addFleetInfo(formData);
        // this.updateTimeSheet(body, this.params.id);
      } else {

        let formData: FormData = new FormData();
        formKeys.forEach(key => {
          formData.append(key, this.createFleet.value[key]);
        });
        formData.append("method_name", "store_fleet_information");
        this.addFleetInfo(formData);
      }
  }

  addFleetInfo(formData) {
    this.api.post(`/tansix_prestart/Fleet_Information/Fleet_Information`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.disableSubmit = false;
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(CabsandFleetinfoPage);
        }

      }, err => {
        console.log("err", err);
        this.disableSubmit = false;

        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  


 async regenerateForm() {
    this.createFleet.patchValue({
      fleet_no: this.params.fleet_no,
      unit_description: this.params.unit_description,
      year_model: this.params.year_model,
      engine_no: this.params.engine_no,
      chassis_no: this.params.chassis_no,
      rego_no: this.params.rego_no,
      amount_purchase: this.params.amount_purchase,
      sale_price: this.params.sale_price,
      location: this.params.location,
      vehicle_category: this.params.vehicle_category,
      vehicle_type: this.params.vehicle_type,
      vehicle_status: this.params.vehicle_status,
     
      serviced_hrs: this.params.serviced_hrs,
      serviced_kms: this.params.serviced_kms,
      current_kms: this.params.current_kms,
      current_hrs: this.params.current_hrs,
      kms_service_due: this.params.kms_service_due,
      Rego_Due_Date: this.params.Rego_Due_Date,
      rego_date: this.params.rego_date,
      suppression_serviced: this.params.suppression_serviced,
      suppression_due: this.params.suppression_due,
      new_price: this.params.new_price,
    });

    this.location = this.params.location;
    this.vehicleCategory = await this.assignName(this.vehicleCategoryList,"ID",this.params.vehicle_category,"vehicle_category");
    this.vehicleType = await this.assignName(this.vehicleTypeList,"ID",this.params.vehicle_type,"vehicle_type");
   
    if(this.params.vehicle_category){
      this.categoryId = this.params.vehicle_category;
    }
    this.geneRateRegoAndDueDate();
  }

  geneRateRegoAndDueDate(){
    let currentDate = new Date()
    let nextYearDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;;
    let nextdate = nextYearDate.toISOString().split('T')[0];
    console.log("nextdate",nextdate)
    if(this.params.rego_date.length == 0){
      this.createFleet.get('rego_date').setValue(date);

    }
    if(this.params.Rego_Due_Date.length == 0){
      this.createFleet.get('Rego_Due_Date').setValue(nextdate);
    }
    
    
  }


  async assignName(list,key,value,returnValue){
        let result = null;
        let index = list.findIndex(list_ => list_[key] == value);
        if(index != -1){
          result = list[index][returnValue];
        }
        return result;
  }


  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  async openModal(list, title, key, value, model, formkey) {
    if(this.isDisabled){
      return;
    }
    
    console.log("list", list)
    list = await this.createData(list, key, value);
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(value,"value",data);
      if (data) {
        this.createFleet.get(formkey).setValue(data.key);
        this[model] = data.value;
        if(value == 'vehicle_category'){
          this.categoryId = data.key;
        }
      }
    });
    profileModal.present();
  }

  suppressionChanged(event:any){
    if(event){
      var now = new Date(event);
      let d = new Date(now.setMonth(now.getMonth() +12));
      this.createFleet.get('suppression_due').setValue(d.toISOString().slice(0, 10));
    }
  }

  open(){
    this.utiltiy.openPdf(`/tansix_prestart/Fleet_Information/Maintenance_Report?plantitem_id=`+this.params.id)
  }


  async getPermission() {
    this.actionAllowed = await this.utiltiy.getPagePermission("cabsand-fleet-information-rw");
  }

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fleetinfo-add/cabsand-fleetinfo-add.ts